import React from "react";
import { BRAND_VALUES } from "@/data/site";

export function Marquee() {
  const items = [...BRAND_VALUES, ...BRAND_VALUES];
  return (
    <div className="relative overflow-hidden border-y border-gold/20 bg-ink py-5" data-testid="brand-marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((v, i) => (
          <span key={`${v}-${i}`} className="mx-8 inline-flex items-center gap-8 font-serif text-xl italic text-gold sm:text-2xl">
            {v}
            <span className="not-italic font-sans text-gold/40">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
